import { Link } from '@remix-run/react'
import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

export const TabbedLinks = React.forwardRef<
  React.ElementRef<'div'>,
  React.ComponentPropsWithoutRef<'div'>
>(({ className, ...props }, ref) => (
  <div
    className={cn(
      'inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground',
      className,
    )}
    ref={ref}
    {...props}
  />
))
TabbedLinks.displayName = 'TabbedLinks'

export const TabbedLink = React.forwardRef<
  React.ElementRef<typeof Link>,
  React.ComponentPropsWithoutRef<typeof Link> & { active?: boolean }
>(({ className, active, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  <Link
    ref={ref}
    className={cn(
      'inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
      active && 'bg-background text-foreground shadow-sm',
      className,
    )}
    {...props}
  />
))
TabbedLink.displayName = 'TabbedLink'
